import React from 'react';
import NoSsr from '@material-ui/core/NoSsr';
import GoogleFontLoader from 'react-google-font-loader';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import { Row, Item } from '@mui-treasury/components/flex';
import { Info, InfoSubtitle, InfoTitle } from '@mui-treasury/components/info';
import { useNewsInfoStyles } from '@mui-treasury/styles/info/news';
import { useCoverCardMediaStyles } from '@mui-treasury/styles/cardMedia/cover';
import Grid from '@material-ui/core/Grid';



   
   const ListService = [
    {title:'Photo fiançailles',img:'./images/fiancaille.webp', alt:"Photo fiancailles"},
    {title:`Photo séance d'engagement`, img: './images/seance-engagement.webp', alt:"Photo séance d'engagement"},
    {title:`Photo EVJF et EVG`, img: './images/evg-evjf.webp', alt:"Photo EVJF et EVG"},
    {title:`Photo préparatifs`, img: './images/preparatif.webp', alt:"Photo préparatifs"},
    {title:`Photo cérémonie civile`, img: './images/mariage-civile.webp', alt:"Photo cérémonie civile"},
    {title:`Photo cérémonie religieuse`, img: './images/mariage-religieux.webp', alt:"Photo cérémonie religieuse"},
    {title:`Photo vin d'honneur`, img: './images/vin.webp', alt:"Photo vin d'honneur"},
    {title:`Photo soirée`, img: './images/soiree.webp', alt:"Photo soirée"},

  ]

const useStyles = makeStyles(() => ({
  card: {
    minWidth: 200,
    position: 'relative',
    boxShadow: '0 8px 24px 0 rgba(0,0,0,0.12)',
    overflow: 'visible',
    borderRadius: '1.5rem',
    transition: '0.4s',
    '&:hover': {
      transform: 'translateY(-10px)',
      '& $shadow': {
        bottom: '-1.5rem',
      },
      '& $shadow2': {
        bottom: '-2.5rem',
      },
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      zIndex: 0,
      display: 'block',
      width: '100%',
      bottom: -1,
      height: '100%',
      borderRadius: '1.5rem',
      backgroundColor: 'rgba(0,0,0,0.08)',
    },
  },
  main: {
    overflow: 'hidden',
    borderTopLeftRadius: '1.5rem',
    borderTopRightRadius: '1.5rem',
    zIndex: 1,
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      display: 'block',
      width: '100%',
      height: '100%',
      /* background: 'linear-gradient(to top, #028E87, rgba(0,0,0,0))', */
    },
  },
  content: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    zIndex: 1,
    padding: '1.5rem 1.5rem 1rem',
    
  },
  avatar: {
    width: 48,
    height: 48,
  },
  tag: {
    display: 'inline-block',
    fontFamily: "'Sen', sans-serif",
    backgroundColor: '#ff5dac',
    borderRadius: '0.5rem',
    padding: '2px 0.5rem',
    color: '#fff',
    marginBottom: '0.5rem',
  },
  title: {
    fontFamily: "'Sen', sans-serif",
    fontSize: '2rem',
    fontWeight: 800,
    color: '#fff',
  },
  author: {
    zIndex: 1,
    position: 'relative',
    borderBottomLeftRadius: '1.5rem',
    borderBottomRightRadius: '1.5rem',
    backgroundColor:'#028E87',
  },
  shadow: {
    transition: '0.2s',
    position: 'absolute',
    zIndex: 0,
    width: '88%',
    height: '100%',
    bottom: 0,
    borderRadius: '1.5rem',
    backgroundColor: 'rgba(0,0,0,0.06)',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  shadow2: {
    bottom: 0,
    width: '72%',
    backgroundColor: 'rgba(0,0,0,0.04)',
  },
}));

export const News3CardDemo = React.memo(function News3Card() {
  const styles = useStyles();
  const mediaStyles = useCoverCardMediaStyles();
  return (
    <>
      <NoSsr>
        <GoogleFontLoader fonts={[{ font: 'Sen', weights: [400, 800] }]} />
      </NoSsr>
            <Grid container spacing={6}>
                    {ListService.map((service,i)=>
                <Grid item xs={12} sm={6} md={3}>
                        <Card className={styles.card}>
                            <Box className={styles.main}  minHeight={300} position={'relative'} >
                            <CardMedia
                                classes={mediaStyles}
                                image={service.img}
                                
                            />
                           {/*  <div className={styles.content}>
                                <div className={styles.tag}>Fashion</div>
                                <Typography variant={'h2'} className={styles.title}>
                                Diana Marvel Has a City Take on the Cowboy Boot
                                </Typography>
                            </div> */}
                            </Box>
                            <Row
                            className={styles.author}
                            m={0}
                            p={3}
                            pt={2}
                            gap={2}
                            bgcolor={'common.white'}
                            >
                            
                            <Info  position={'middle'} useStyles={useNewsInfoStyles}>
                                <h3  style={{fontSize:14,color:'#FF945F',fontFamily:'LemonMilk-Regular',textShadow:"0px 4px 4px rgba(0, 0, 0, 0.25)"}}>{service.title}</h3>
                                
                            </Info>
                            </Row>
                            <div className={styles.shadow} />
                            <div className={`${styles.shadow} ${styles.shadow2}`} />
                        </Card>
            


                

                </Grid>
                    )}

            </Grid>



            
      
    </>
  );
});
export default News3CardDemo